import { observable } from "mobx";
import { Expose } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class FormResponse {
  @observable
  message?: string[];

  @observable
  @Expose({ name: "sap_notice" })
  sapNotice?: string;
}
